import TerritoryModule from "@/pages/super-admin/components/TerritoryModule";

export default function SuperAdminSecteursPage() {
  return <TerritoryModule level="secteur" />;
}